<div class="card">
  <div class="card-body text-center">
    <h3 class="font-size-20 font-page-heading">{{ 'mobile.pass.download' | translate }}</h3>
    <p>{{ 'mobile.pass.description' | translate }}</p>
    <qrcode *ngIf="url" [qrdata]="url" [width]="256" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
  </div>
</div>
